import { FuseNavigation } from 'admin/@fuse/types';
import { SectionPermission } from 'admin/appModel/Company';
import { AppConstants } from 'admin/utile/AppConstants';

export const navigation: FuseNavigation[] = [
    {
        id: 'dashboard',
        title: 'Dashboard',
        type: 'item',
        url: '/dashboard'
    },
    {
        id: 'agent-group',
        //title: 'Agent',
        title: null,
        classes: 'group-title-empty',
        type: 'group',
        Agent: true,
        children: [
            {
                id: 'agent-profile',
                title: 'Profile',
                type: 'item',
                Agent: true,
                permissionName: SectionPermission.AgentProfile, //'AgentProfile',
                url: '/agentprofile'
            },
            {
                id: 'agent-contact',
                title: 'Contact',
                type: 'item',
                Agent: true,
                permissionName: SectionPermission.AgentContact, //'AgentContact',
                url: '/agentcontact'
            },
            {
                id: 'agent-properties',
                title: 'Properties',
                type: 'item',
                Agent: true,
                permissionName: SectionPermission.AgentProperties, //'AgentProperties',
                url: '/agentlistings'
            },
            {
                id: 'agent-website',
                title: 'Website',
                type: 'item',
                Agent: true,
                permissionName: SectionPermission.AgentWebsite, // 'AgentWebsite',
                url: '/agentwebsite'
            }
        ]
    },
    {
        id: 'company-group-collapsable',
        title: 'Company',
        //title: null,
        //classes: 'group-title-empty',
        type: 'collapsable',
        Agent: true,
        children: [
            {
                id: 'agents',
                title: 'Agents',
                type: 'item',
                permissionName: SectionPermission.Agents, // 'Agents',
                url: '/agents'
            },
            {
                id: 'properties',
                title: 'Properties',
                type: 'item',
                permissionName: SectionPermission.Properties, // 'Properties',
                url: '/listings'
            },
            {
                id: 'website',
                title: 'Company',
                type: 'item',
                permissionName: SectionPermission.CompanyWebsite, // 'Website',
                url: '/companywebsite'
            },
            {
                id: 'resources-group',
                //title: 'Resources',
                title: null,
                classes: 'group-title-empty',
                type: 'group',
                children: [
                    {
                        id: 'filemanager',
                        title: 'File Manager',
                        type: 'item',
                        permissionName: SectionPermission.FileManager, // 'FileManager',
                        url: '/filemanager'
                    },
                    {
                        id: 'info',
                        title: 'Info',
                        type: 'item',
                        permissionName: SectionPermission.CompanyInfo, // 'Contact',
                        url: '/contact'
                    }
                ]
            }
        ]
    },
    {
        id: 'company-group',
        //title: 'Company',
        title: null,
        classes: 'group-title-empty',
        type: 'group',
        Agent: false,
        children: [
            {
                id: 'agents',
                title: 'Agents',
                type: 'item',
                permissionName: SectionPermission.Agents, // 'Agents',
                url: '/agents'
            },
            {
                id: 'listings',
                title: 'Properties',
                type: 'item',
                permissionName: SectionPermission.Properties, // 'Properties',
                url: '/listings'
            },
            {
                id: 'website',
                title: 'Company',
                type: 'item',
                permissionName: SectionPermission.CompanyWebsite, // 'Website',
                url: '/companywebsite'
            },
            {
                id: 'resources-group',
                //title: 'Resources',
                title: null,
                classes: 'group-title-empty',
                type: 'group',
                children: [
                    {
                        id: 'filemanager',
                        title: 'File Manager',
                        type: 'item',
                        permissionName: SectionPermission.FileManager, // 'FileManager',
                        url: '/filemanager'
                    },
                    {
                        id: 'info',
                        title: 'Info',
                        type: 'item',
                        permissionName: SectionPermission.CompanyInfo, // 'Contact',
                        url: '/contact'
                    }
                ]
            }
        ]
    },
    {
        id: 'account-group-holder',
        title: null,
        classes: 'group-title-empty',
        type: 'group',
        isAccount: true,
        children: [
            {
                id: 'account-group',
                title: 'Account',
                type: 'collapsable',
                isAccount: true,
                children: [
                    {
                        id: 'settings',
                        title: 'Settings',
                        type: 'item',
                        isAccount: true,
                        url: '/settings'
                    },
                    {
                        id: 'devtools',
                        title: 'Dev Tools',
                        type: 'item',
                        isDevTools: true,
                        permissionName: SectionPermission.DeveloperTools,
                        url: '/devtools'
                    },
                    {
                        id: 'logout',
                        title: 'Logout',
                        type: 'item',
                        isAccount: true,
                        redirectTo: AppConstants.baseUrl + '/account/user',
                        function: () => { }
                    }
                ]
            }
        ]
	},
	{
		id: 'contact-us',
		title: 'Contact Us',
		type: 'item',
		isAccount: true,
		function: () => { }
	}
];
